import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';

import { AuthState } from '@app/data/state';

export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  if (store.selectSnapshot(AuthState.isAuthenticated)) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
